import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandService } from './brand.service';

@NgModule({
  imports: [CommonModule],
  providers: [BrandService]
})
export class BrandModule {}
